import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonSet from '@jetbrains/ring-ui/components/button-set/button-set'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'

import {isKey} from '../../../../../../utils/guards'
import {buildLogSearchHint} from '../../../../Hints/HintItems/Hints.buildOverview'
import {stringifyHintId} from '../../../../Hints/Hints.types'
import BuildLogFilterMenu, {filterLabels} from '../../BuildLogFilterMenu/BuildLogFilterMenu'

import useBuildLogControls from './BuildLogControls.hooks'

type Props = {
  setSearchActive: (searchActive: boolean) => unknown
}

export default function BuildLogControls({setSearchActive}: Props) {
  const {
    filterValue,
    searchEnabled,
    messagesExists,
    showSearch,
    onExpandAllClick,
    onCollapseAllClick,
  } = useBuildLogControls(setSearchActive)

  return (
    <ButtonSet data-test-full-build-log="controls">
      <Button
        onClick={onExpandAllClick}
        disabled={!messagesExists}
        data-test-full-build-log={'expand'}
      >
        {'Expand All'}
      </Button>
      <Button
        onClick={onCollapseAllClick}
        disabled={!messagesExists}
        data-test-full-build-log={'collapse'}
      >
        {'Collapse All'}
      </Button>
      <Dropdown
        anchor={
          <Button disabled={!messagesExists} data-test-full-build-log={'filter'} dropdown>
            {`${
              filterValue && isKey(filterLabels, filterValue)
                ? filterLabels[filterValue]
                : filterLabels.all
            } `}
          </Button>
        }
      >
        <BuildLogFilterMenu />
      </Dropdown>
      {searchEnabled && (
        <Button
          data-hint-container-id={stringifyHintId(buildLogSearchHint.id)}
          onClick={showSearch}
          disabled={!messagesExists}
          data-test-full-build-log={'open-search'}
        >
          {'Search in log...'}
        </Button>
      )}
    </ButtonSet>
  )
}
